import { authReducer } from './slices';
import { washhubReducer } from './slices/washhub';
import { currentWeekReducer } from './slices/currentWeek';

export default {
  auth: authReducer,
  washhub: washhubReducer,
  currentWeek: currentWeekReducer,
};
